// Japanese

const lang = {
  gateMediaPreviewHeader: 'こちらもお好みに合うかもしれません',
  loadmore: 'もっと表示',
  nextMedia: '次のメディア',
  previousMedia: '前のメディア',
  closePost: '投稿を閉じる',
  nextPost: '次の投稿',
  previousPost: '前の投稿',
  outOfStock: '在庫切れ',
  numberOfReviews() {
    return '件のレビュー'
  },
  reportFormField: 'メッセージを入力してください',
  reportPost: '投稿を報告する',
  reportFormTitle: 'この画像を報告しますか？',
  reportFormDetails:
    '画像が不適切、違法、または誰かの権利を侵害していると思われる場合は、コンテンツを報告できます。画像/テキストを報告すると、コンテンツモデレーターに通知され、適切な処置がとられます',
  reportFormMessagePlaceholder: '報告の理由を明記してください',
  reportFormMessageLabel: 'メッセージ',
  reportFormEmailLabel: 'お客様のEメール',
  reportFormSubmitButtonText: '報告を送信する',
  reportFormCancelButtonText: 'キャンセル',
  reportFormSentTitle: 'ご報告ありがとうございます',
  reportFormSentCloseButtonText: '閉じる',
  cardAndTileAriaLabel: 'さまざまなソーシャルメディアアカウントの投稿リスト',
  carouselAriaLabel: 'さまざまなソーシャルメディアアカウントの投稿のカルーセル',
  singleAriaLabel: '以下はソーシャルメディアアカウントからの投稿です',
  poweredBy: '提供元：Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date && !userName ? `${date} に投稿された写真` : ''
    const createdByString = userName && !date ? `${userName} が投稿した写真` : ''
    const fullString = date && userName ? `${date} に ${userName} が投稿した写真` : ''
    const photo = !date && !userName ? '写真' : ''
    return `${fullString}${photo}${createdByString}${publishedString}`
  },
  uploadYourMedia: 'メディアをアップロードする',
  openTheGate: 'ダイアログを開く',
  gridRoleDescription: 'グリッド',
  carouselRoleDescription: 'カルーセル',
  tiktokVideoAriaLabel: '埋め込みTikTok動画。再生ボタンを押してコンテンツを表示。',
  feedThumbnailAriaLabel: (postIndex, maxPosts) =>
    `メディアサムネイル ${postIndex + 1} / ${maxPosts}。ソーシャルメディアコンテンツと注目商品のリストを含むダイアログを開きます。`,
  carouselControlButtonsAriaLabel: 'カルーセルコントロールボタン',
  gateCarouselIndicatorAriaLabel: (mediaIndex, maxMedia) =>
    `メディア ${mediaIndex + 1} / ${maxMedia}`,
  showMoreCaption: 'キャプションをもっと見る',
  showLessCaption: 'キャプションを閉じる',
  originalPrice: (price) => `元の価格：${price}`,
  salesPrice: (price) => `セール価格：${price}`,
  postPublishedBy: '投稿者',
  mediaAltText: (isVideo, username, date, altText) => {
    const mediaType = isVideo ? 'ビデオ' : '画像'
    const user = username ? `${username}` : '不明なユーザー'
    const publishDate = date ? `${date}に` : ''
    return `${user}が${publishDate}投稿した${mediaType}です。${altText}かもしれません。`
  },
  gateSlideAriaLabel: (postIndex, maxPosts) => `投稿 ${postIndex + 1} ／ ${maxPosts} 件中`,
}

export default lang
